var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Graph/User Groups") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Graph/User-Groups",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#658BD3",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uF0C0",
    transform: "translate(8.665737, 10.209263)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74726546,8.75 C10.3170702,8.75 11.5664062,7.47687507 11.5664062,5.90625 C11.5664062,4.33562493 10.2938279,3.0625 8.74726546,3.0625 C7.17746067,3.0625 5.92812467,4.33562493 5.92812467,5.90625 C5.90351546,7.47578108 7.17773438,8.75 8.74726546,8.75 Z M10.114453,9.625 L7.38554704,9.625 C5.23906267,9.625 3.5,11.2574222 3.5,13.2699215 C3.5,13.6746095 3.84726554,14 4.27656233,14 L13.2234377,14 C13.652734,14 14,13.6746095 14,13.2699215 C14,11.2574222 12.2609373,9.625 10.114453,9.625 Z M14,4.375 C15.2080467,4.375 16.1875,3.39554667 16.1875,2.1875 C16.1875,0.979453325 15.2085941,0 14,0 C12.7919533,0 11.8125,0.979453325 11.8125,2.1875 C11.8125,3.39554667 12.7914059,4.375 14,4.375 Z M5.02851546,5.90625 C5.02851546,5.75725377 5.05537814,5.6155858 5.07251137,5.47121084 C4.77421892,5.30742204 4.44609392,5.25 4.09882796,5.25 L2.40843755,5.25 C1.07843757,5.25 0,6.39296883 0,7.80117154 C0,8.08281267 0.215659976,8.3125 0.481796741,8.3125 L5.93687487,8.3125 C5.37851554,7.66171908 5.02851546,6.82773429 5.02851546,5.90625 Z M3.5,4.375 C4.70804667,4.375 5.6875,3.39554667 5.6875,2.1875 C5.6875,0.979453325 4.70859367,0 3.5,0 C2.29195291,0 1.31249958,0.979453325 1.31249958,2.1875 C1.31249958,3.39554667 2.29195291,4.375 3.5,4.375 Z M15.0910163,5.25 L13.4000789,5.25 C13.0500792,5.25 12.7197663,5.33304304 12.4195316,5.47531265 C12.4359372,5.61914062 12.4632809,5.75859392 12.4632809,5.90625 C12.4632809,6.82800758 12.1138278,7.66199195 11.5565621,8.3125 L17.0171084,8.3125 C17.2839837,8.3125 17.5,8.08281267 17.5,7.80117154 C17.5,6.39296883 16.4226556,5.25 15.0910163,5.25 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroups);
export default __webpack_public_path__ + "static/media/UserGroups.4eaf23451ef86437717aad3f4c9f5048.svg";
export { ForwardRef as ReactComponent };